//import "devextreme/dist/css/dx.carmine.compact.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
import { HashRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";

import { Provider, useSelector } from "react-redux";
import reduxStore from "./redux/index";
import { PersistGate } from "redux-persist/integration/react";

import enMessages from "devextreme/localization/messages/en.json";
import trMessages from "devextreme/localization/messages/tr.json";
import { locale as devexLocale, loadMessages } from "devextreme/localization";
import { useEffect } from "react";
import { languageSelector } from "./redux/language";
import { isLoading } from "./redux/loader";
import { loggedSelector } from "./redux/auth";

const { store, persistor } = reduxStore();

function App() {
  const language = useSelector(languageSelector);
  const loading = useSelector(isLoading);
  const loggedIn = useSelector(loggedSelector);



  useEffect(() => {
    loadMessages(enMessages);
    loadMessages(trMessages);
    if (language) devexLocale(language.Code);
  }, [language]);

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (loggedIn) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <App />
            </div>
          </NavigationProvider>
        </PersistGate>
      </Provider>
    </Router>
  );
}
